import Token from '@/utils/Token';
import Mask from '@/utils/Mask';

export default {
    parse(data) {
        ['valor_referencia'].forEach(item => {
            if (data[item]) {
                data[item] = parseFloat(data[item]);
            }
        });

        ['data_instalacao'].forEach(item => {
            if (data[item]) {
                data[item] = new Date(data[item] + "T00:00:00");
            }
        });

        return data;
    },
    get(id, params="") {
        if(params) params = `?${params}`;
        return axios.get(`/api/contrato-conta/${id}${params}`, Token.getHeader());
    },
    list(params="") {
        if(params) params = `?${params}`;
        return axios.get(`/api/contrato-conta/list${params}`, Token.getHeader());
    },

    update(id,params) {
        return axios.post(`/api/contrato-conta/${id}`, params, Token.getHeader());
    },
    delete(id) {
        return axios.delete(`/api/contrato-conta/${id}`, Token.getHeader());
    },
}
